export default "__VITE_ASSET__NnqvoM5i__"